import React from 'react';

import * as S from './styles';

const Gallery01: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Photo1
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="200ms"
        />
        <S.Photo2
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="400ms"
        />
      </S.Wrapper>
      <S.Caption>
        <p className="desktop">
          O verão 2023 de Thom Browne joga com a ideia de uniformes opostos, do
          ideário masculino (à esq.) a uma nova visão desse homem a partir do
          guarda-roupas feminino (à dir.). Getty Images
        </p>
        <p className="mobile">
          O verão 2023 de Thom Browne joga com a ideia de uniformes opostos, do
          ideário masculino a uma nova visão desse homem a partir do
          guarda-roupas feminino. | Fotos: Getty Images
        </p>
      </S.Caption>
    </S.Container>
  );
};

export default Gallery01;
